const AUTH_TOKEN = $('meta[name="csrf-token"]').attr('content');

window.CreateDealPricingRequest = {
    init() {
        this.initDropZone();
        // Reused attachments carried over from a prior request are rendered server-side before
        // any upload happens, so their remove buttons need binding here too — not just after a
        // new upload succeeds (see the `success` callback below).
        this.handleOnClickRemoveAttachment();
    },

    initDropZone() {
        const submitButton = document.getElementById('pricing-continue-modal-btn');

        const showPreviewLoader = (file) => {
            if (!file?.previewElement) return;
            $(file.previewElement).find('.dz-uploading-loader').removeClass('d-none');
            $(file.previewElement).find('.dz-remove').addClass('d-none'); // avoid removing mid-upload
        };

        const hidePreviewLoader = (file) => {
            if (!file?.previewElement) return;
            $(file.previewElement).find('.dz-uploading-loader').addClass('d-none');
            $(file.previewElement).find('.dz-remove').removeClass('d-none');
        };

        $(".add-pricing-request-btn").not(".dz-clickable").each((index, element) => {
            const category = element.dataset.category || 'other';

            $(element).dropzone({
                url: "/deal_pricing_requests/upload_deal_pricing_request_attachment",
                previewsContainer: document.querySelector('.drop-zone-preview.pricing-request'),
                previewTemplate: document.querySelector('.drop-zone-custom.pricing-request').innerHTML,
                uploadMultiple: false,
                maxFiles: 10,
                maxFileSize: 10,
                acceptedFiles: ".jpg,.jpeg,.gif,.png,.tiff,.bmp,.webp,.txt,.csv,.pdf,.xls,.xlsx,.xlsm,.doc,.docx,.zip",
                init: function () {
                    this.on("error", function (file) {
                        hidePreviewLoader(file);
                        this.removeFile(file);
                        $('#deal-pricing-request-attachments').after(
                            '<div class="alert alert-danger alert-dismissable" id="rr-success-alert">' +
                            '<button type="button" class="close" ' +
                            'data-dismiss="alert" aria-hidden="true">' +
                            '&times;' +
                            '</button>' +
                            'An error has occurred uploading file' +
                            '</div>'
                        );
                        submitButton.disabled = false;
                    });

                    this.on("complete", function (file) {
                        hidePreviewLoader(file);
                    });
                },
                params: {
                    'authenticity_token': AUTH_TOKEN,
                    'category': category
                },
                timeout: 60000,
                success: (file, response) => {
                    if (response.err_msg == '' || response.err_msg == undefined) {
                        const dealPricingRequestAttachmentsElement = $("#deal-pricing-request-attachments");
                        $(file.previewElement).find('.remove-attachment').attr('data-attachment-id', response.id);
                        dealPricingRequestAttachmentsElement.append(`<input type='hidden' value='${response.id}' name='deal_pricing_request[deal_pricing_request_attachment_ids][]'>`);
                    } else {
                        alert(response.err_msg);
                        file.previewElement.remove();
                    }
                    submitButton.disabled = false;
                },
                sending: (file) => {
                    showPreviewLoader(file);
                    submitButton.disabled = true;
                }
            });
        });

        $("#rr-success-alert").fadeTo(5000, 500).slideUp(500, function () {
            $("#rr-success-alert").slideUp(500);
        });
        setTimeout(function () {
            $("#rr-success-alert").remove();
        }, 6000);
    },

    handleRemoveAttachment(e) {
        const attachmentId = e.currentTarget.dataset.attachmentId;
        $(`#deal-pricing-request-attachments :input[value="${attachmentId}"]`).remove();
        $(e.currentTarget).closest('.dz-preview').remove();
    },

    handleOnClickRemoveAttachment() {
        // Delegated so it covers both attachments already in the DOM (e.g. reused from a prior
        // request) and ones added later (newly uploaded files) without needing to re-bind — and
        // without risking the same element getting a duplicate handler.
        $(document).off('click.removeAttachment', '.remove-attachment')
            .on('click.removeAttachment', '.remove-attachment', this.handleRemoveAttachment.bind(this));
    },
};
